import React from 'react';
import { motion } from 'motion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faBolt, faGem } from '@fortawesome/free-solid-svg-icons';
import DarkVeil from './DarkVeil';
import Button from '../common/Button';
import Badge from '../common/Badge';
import { revealStagger } from '../../utils/motion';

export default function CTASection() {
  return (
    <section className="lp-cta">
      <div className="lp-cta-bg" aria-hidden="true">
        <DarkVeil
          hueShift={0}
          noiseIntensity={0}
          scanlineIntensity={0}
          speed={0.5}
          scanlineFrequency={0}
          warpAmount={0}
        />
      </div>

      <div className="lp-container lp-cta-inner">
        <motion.div
          variants={revealStagger.container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div variants={revealStagger.item}>
            <Badge variant="cyan" pulsing size="sm" style={{ marginBottom: '1.25rem' }}>
              JOIN 1,200+ ACTIVE INVESTORS
            </Badge>
          </motion.div>

          <motion.h2 className="lp-cta-title" variants={revealStagger.item}>
            Ready to <span className="lp-gradient-text">Own Fine Art</span>?
          </motion.h2>

          <motion.p className="lp-cta-desc" variants={revealStagger.item}>
            Experience verified institutional provenance, fractional TitTat liquidity,
            and real-time auction discovery in a unified, next-generation exchange.
          </motion.p>

          <motion.div
            className="lp-hero-actions"
            style={{ opacity: 1, animation: 'none', justifyContent: 'center' }}
            variants={revealStagger.item}
          >
            <Button to="/signup" variant="primary" size="lg" trailingIcon="→">
              Create Free Account
            </Button>
            <Button to="/marketplace" variant="secondary" size="lg">
              Explore Marketplace
            </Button>
          </motion.div>

          <motion.div className="lp-cta-trust-bar" variants={revealStagger.item}>
            <span className="lp-trust-item">
              <FontAwesomeIcon icon={faShieldHalved} style={{ marginRight: '6px', color: '#06b6d4' }} />
              Encrypted Institutional Escrow
            </span>
            <span className="lp-trust-sep">•</span>
            <span className="lp-trust-item">
              <FontAwesomeIcon icon={faBolt} style={{ marginRight: '6px', color: '#f59e0b' }} />
              Instant Fractional Trading
            </span>
            <span className="lp-trust-sep">•</span>
            <span className="lp-trust-item">
              <FontAwesomeIcon icon={faGem} style={{ marginRight: '6px', color: '#10b981' }} />
              100% Artist Verified
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
